function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemPart = function SvgLivemapSearchresultItemPart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16.031 15.938"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M297 428.068v-7.951h3.5a5.926 5.926 0 0 0 .654-.028c.417-.351-.284-.864-.284-1.923a2.3 2.3 0 0 1 4.586 0c0 1.017-.622 1.526-.305 1.875a3.45 3.45 0 0 0 .888.069h2.865v3.535a5.8 5.8 0 0 0 .028.648c.354.414.871-.282 1.938-.282a2.279 2.279 0 0 1 0 4.551c-1.025 0-1.537-.618-1.89-.3a3.4 3.4 0 0 0-.069.882v2.842H297v-1.444Z",
    style: {
      fill: "#66b3c0",
      fillRule: "evenodd"
    },
    transform: "translate(-297 -416.031)"
  }));
};
export default SvgLivemapSearchresultItemPart;